import axios from "axios";
import { showToast } from "../mixins/Common";
import { store } from "../store/store";
import apiPath from "@/constants/api";

let apiHeaders = {
  "Content-Type": "multipart/form-data"
};

let apiRequest = axios.create({
  headers: apiHeaders
});

apiRequest.interceptors.response.use(
  response => {
    return response;
  },
  function(error) {
    store.dispatch("setLoading", false);
    showToast(error);
  }
);

export default {
  uploadImage(data) {
    const response = apiRequest.post(apiPath.imageUpload, data);
    return response;
  }
};
